import axios from "axios";
import store from "@/store";
import router from "@/router";
import {findObjectIndex} from "../class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

const reshapeForm = (form) => {
    if (form.type === "text") {
        form.feature_attributes = [form.feature_attributes];
    }
    return form;
};

export default {
    namespaced: true,
    state: {
        features: [],
        links: {},
        meta: {},
        searchWord: null,
        filteredFeatures: [],
        trash: [],
    },
    mutations: {
        setFeatures(state, features) {
            state.features = features;
        },
        setLinks(state, links) {
            state.links = links;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        deleteFeature(state, feature) {
            state.features = state.features.filter((f) => f.id !== feature.id);
        },
        setfilteredFeatures(state, filteredFeatures) {
            state.filteredFeatures = filteredFeatures;
        },
        destroyFearure: (state, feature) => {
            state.features.splice(
                findObjectIndex(store.getters["Feature/getFeatures"], feature),
                1
            );
            state.trash.splice(
                findObjectIndex(store.getters["Feature/getTrash"], feature),
                1
            );
        },
        setTrash(state, features) {
            state.trash = features;
        },
    },
    actions: {
        getFeatures({commit}, page = 1) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/feature?page=${page}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setFeatures", response.data);
                        commit("setfilteredFeatures", response.data);
                        commit("setLinks", response.links);
                        commit("setMeta", response.meta);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async getFeature({commit}, form) {
            return await axios.get(`feature/${form.id}`);
        },
        createFeature({commit}, form) {
            axios
                .post("/feature", form)
                .then((response) => {
                    const feature = response.data.data;
                    const features = {
                        ...store.getters["Feature/getFeatures"],
                        ...feature,
                    };
                    commit("setFeatures", features);
                    router.push({name: "UpdateFeature", params: {id: feature.id}});
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateFeature({commit}, form) {
            axios
                .put(`/feature/${form.id}`, reshapeForm(form))
                .then((response) => {
                    const feature = response.data.data;
                    const features = {
                        ...store.getters["Feature/getFeatures"],
                        ...feature,
                    };
                    commit("setFeatures", features);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateFeatureAttribute({commit}, form) {
            axios
                .post(`feature-attributes/update/feature/${form.feature_id}/feature-attribute/${form.feature_attribute_id}`, form)
                .then((response) => {
                    const feature = response.data.data;
                    const features = {
                        ...store.getters["Feature/getFeatures"],
                        ...feature,
                    };
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                    commit("setFeatures", features);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async createFeatureAttribute({commit}, form) {

            const response = await axios.post(`/feature-attributes/create/feature/${form.feature_id}`, form);
            const feature = await response.data.data;
            toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
            return await feature
        },
        filteredFeatures({commit}, word) {
            axios
                .post("/feature/search", word)
                .then((res) => {
                    const feature = res.data.data.data;
                    commit("setfilteredFeatures", feature);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeFeature({commit}, feature) {
            axios
                .delete(`/feature/${feature.id}`)
                .then((res) => {
                    const deletedFeature = res.data.data;
                    commit("destroyFearure", deletedFeature);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeFeatureAttribute({commit}, form) {
            axios
                .delete(`feature-attributes/delete/feature-attribute/${form.feature_attribute_id}`)
                .then((res) => {
                    const deletedFeature = res.data.data;
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                    commit("destroyFearure", deletedFeature);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        trashFeatures({commit}, page = 1) {
            axios
                .post(`/feature/trash?page=${page}`)
                .then((res) => {
                    const trashItems = res.data.data.data;
                    commit("setTrash", trashItems);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        restoreFeature({commit}, feature) {
            axios
                .put(`/feature/${feature.id}/restore`)
                .then((res) => {
                    const restoredFeature = res.data.data;
                    commit("destroyFearure", restoredFeature);
                    const features = {
                        ...store.getters["Feature/getFeatures"],
                        restoredFeature,
                    };
                    commit("setFeatures", features);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        forceDeleteFeature({commit}, feature) {
            axios
                .delete(`/feature/${feature.id}/force-delete`)
                .then((res) => {
                    const deletedFeature = res.data.data;
                    commit("destroyFearure", deletedFeature);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    getters: {
        getFeatures: (state) => state.features,
        getPaginationLinks: (state) => state.links,
        getPaginationMeta: (state) => state.meta,
        getFilteredFeatures: (state) => state.filteredFeatures,
        getTrash: (state) => state.trash,

    },
};
